// Note: This file is used to store all the constants used in the application
export const API_URL = {
  VALIDATION_ANTI_SPIDER: '/risk/verify/identity/validation/anti/spider',
  VALIDATION_ANTI_FLOW_CHECK: '/risk/verify/identity/validation/flow_check',
};

// The server type
export const SERVER_TYPE = {
  development: {
    central: 'https://pc-test25.shein.com',
    us: 'https://pc-test25.shein.com',
    eur: 'https://pc-test25.shein.com'
  },
  production: {
    central: 'https://zpnv.shein.com',
    us: 'https://zpnv-us.shein.com',
    eur: 'https://zpnv-eur.shein.com'
  }
}

// The sm server type
export const SM_SERVER_TYPE = {
  development: {
    central: 'pc-test25.shein.com',
    us: 'pc-test25.shein.com',
    eur: 'pc-test25.shein.com'
  },
  production: {
    central: 'zpnv.shein.com',
    us: 'zpnv-us.shein.com',
    eur: 'zpnv-eur.shein.com'
  }
}

// The js server type
export const JS_SERVER_TYPE = {
  development: {
    central: 'pc-test25.shein.com',
    us: 'pc-test25.shein.com',
    eur: 'pc-test25.shein.com'
  },
  production: {
    central: 'armor.ltwebstatic.com',
    us: 'armor.ltwebstatic.com',
    eur: 'armor.ltwebstatic.com'
  }
}

// The environment type
export const DEBUG_ENV = {
  development: 'development',
  production: 'production',
}

// The store name
export const KEEP_STORE_NAME = 'si_anti_spider'

// The default anti-spider configuration
export const DEFAULT_ANTI_SPIDER = {
  anti_in: {
    url: 'https://armor.ltwebstatic.com/she_dist/armor-libs/antiin/antiin.1.9.1.min.js',
    hit: [
      '/risk/verify/identity/validation/risk/id',
      '/risk/verify/identity/validation/token',
      '/risk/verify/identity/validation/passive/token',
      '/risk/verify/identity/validation/question',
      '/risk/verify/identity/validation/send',
      '/risk/verify/identity/validation/prefetch',
      '/risk/verify/identity/validation/resources',
      '/risk/verify/identity/validation/check',
      '/risk/verify/identity/validation/feedback',
      '/risk/verify/identity/validation/anti/spider',
      '/risk/verify/identity/validation/flow_check',
      '/risk/verify/identity/geetest/register',
      '/risk/verify/identity/geetest/get.php',
      '/risk/verify/identity/geetest/ajax.php',
      '/risk/verify/identity/geetest/reset.php',
      '/risk/verify/identity/geetest/refresh.php'
    ]
  },
  infp: {
    url: 'https://armor.ltwebstatic.com/she_dist/armor-libs/infp/infp.3.10.0.min.js'
  },
  main: {
    url: 'https://common.ltwebstatic.com/dist_bundle/xjqHR52UWJdjKJ0x6QrCsus66rNXR9/2.0.13/1/main.js'
  },
  sm: {
    url: 'https://armor.ltwebstatic.com/she_dist/libs/devices/fpv2.7.js'
  },
  td: {
    central: {
      appName: 'shein_central_web',
      partner: 'shein_central',
      url: 'https://armor.ltwebstatic.com/she_dist/armor-libs/risk_libs/fm.us.4.1.2.js',
      normal: 'https://armor.ltwebstatic.com/she_dist/armor-libs/risk_libs/normal.us.4.1.2.js'
    },
    us: {
      appName: 'shein_us_web',
      partner: 'shein_us',
      url: 'https://armor.ltwebstatic.com/she_dist/armor-libs/risk_libs/fm.us.4.1.2.js',
      normal: 'https://armor.ltwebstatic.com/she_dist/armor-libs/risk_libs/normal.us.4.1.2.js'
    },
    eur: {
      appName: 'shein_eur_web',
      partner: 'shein_eur',
      url: 'https://armor.ltwebstatic.com/she_dist/armor-libs/risk_libs/fm.eur.4.1.2.js',
      normal: 'https://armor.ltwebstatic.com/she_dist/armor-libs/risk_libs/normal.eur.4.1.2.js'
    }
  },
  riskified: {
    url: 'https://beacon.riskified.com?shop=www.shein.com'
  },
  cybersource: {
    url: 'https://h.online-metrix.net/fp/tags.js',
    match: [
      {
        matchKey: 'SHEIN_US',
        merchant: 'shein_risk_manager',
        orgId: 'k8vif92e'
      },
      {
        matchKey: 'ROMWE_US',
        merchant: 'riskromwe',
        orgId: 'k8vif92e'
      },
      {
        matchKey: 'NO_US',
        merchant: 'sheincenter',
        orgId: 'k8vif92e'
      }
    ]
  },
  forter: {
    url: 'https://armor.ltwebstatic.com/she_dist/armor-libs/forter/forter.2.31.js',
    not_us: 0
  },
  csrandom: {
    url: 'https://armor.ltwebstatic.com/she_dist/armor-libs/csrandom/csrandom.1.0.6.min.js',
    hit: [
      '/risk/verify/identity/validation/token',
      '/risk/verify/identity/validation/passive/token',
      '/risk/verify/identity/validation/question',
      '/risk/verify/identity/validation/send',
      '/risk/verify/identity/validation/prefetch',
      '/risk/verify/identity/validation/resources',
      '/risk/verify/identity/validation/check',
      '/risk/verify/identity/validation/feedback',
      '/risk/verify/identity/validation/anti/spider',
      '/risk/verify/identity/validation/flow_check',
      '/risk/verify/identity/geetest/register',
      '/risk/verify/identity/geetest/get.php',
      '/risk/verify/identity/geetest/ajax.php',
      '/risk/verify/identity/geetest/reset.php',
      '/risk/verify/identity/geetest/refresh.php',
      '/risk/verify/identity/validation/risk/id'
    ],
    interval: 86400000
  }
}

// The metric name
export const METRIC_NAME = 'si_anti_spider_sdk_c'

// The channel type
export const CHANNEL_TYPE = ['pc', 'pwa', 'android', 'ios', 'h5']

//  The icon types
export const ICON_TYPES = { 903: 'js_challenge', 904: 'slide', 905: 'click', 910: 'nine_captcha', 909: 'one_pass' }

//  cookie
export const LLBS_COOKIE_NAME = '_f_c_llbs_'

// The SDK version auto change
export const SDK_VERSION = '0.0.50'

// The metric name fetch
export const METRIC_NAME_F = 'si_anti_spider_sdk_n'

// The metric name rewrite
export const METRIC_NAME_REWRITE = 'si_anti_spider_sdk_rw'

// The metric name commonInfoChanged
export const METRIC_NAME_COMMON_INFO_CHANGED = 'si_anti_spider_sdk_cic'

// The metric name monitor js load time
export const METRIC_NAME_MONITOR_JS_LOAD_TIME = 'si_anti_spider_sdk_mjlt'

// The metric name black_friday
export const METRIC_NAME_BLACK_FRIDAY = 'si_anti_spider_sdk_black_friday'

// The metric name check back
export const METRIC_NAME_CHECK_BACK = 'si_anti_spider_sdk_check_back'

// The metric name forter ready
export const METRIC_NAME_FORTER_READY = 'si_anti_spider_sdk_forter_ready'